import React, { useEffect, useMemo, useState } from 'react';
import { parseWheelInspection } from '../../utils/wheelInspectionUtil';
import WheelReportPhotoPositionGroup from './WheelReportPhotoPositionGroup';
import {
  buildPostPhotoGroups,
  paginateGroups,
  POST_GROUPS_PER_PAGE,
} from './wheelReportPhotoUtil';
import './WheelRestorationReport.scss';

/** 복원후 사진 — 페이지당 위치 그룹 2개(각 2×2, 최대 8장) */
const WheelRestorationPhotoPages = ({ photos = [], vehicleInformation = {} }) => {
  const inspection = parseWheelInspection(vehicleInformation);
  const [resolvedPhotos, setResolvedPhotos] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!photos?.length) {
        setResolvedPhotos([]);
        return;
      }
      const base = process.env.REACT_APP_S3_BASE_URL || '';
      const resolved = await Promise.all(
        photos.map(async (img) => ({
          ...img,
          src: img.src || (img.filePath ? `${base}${img.filePath}` : ''),
        }))
      );
      if (!cancelled) setResolvedPhotos(resolved);
    })();
    return () => {
      cancelled = true;
    };
  }, [photos]);

  const postGroupPages = useMemo(() => {
    const findSrc = (partCode) =>
      resolvedPhotos.find((p) => p.partCode === partCode && p.src)?.src || null;
    const groups = buildPostPhotoGroups(inspection, findSrc);
    return paginateGroups(groups, POST_GROUPS_PER_PAGE);
  }, [resolvedPhotos, inspection]);

  if (!postGroupPages.length) return null;

  return postGroupPages.map((pageGroups, pageIndex) => (
    <div key={`wheel_post_photo_${pageIndex}`} className="paper_container">
      <div className="paper wheel-restoration-paper wheel-restoration-photo-paper flex flex-column">
        <div className="watermark"></div>
        <div className="wheel-report-post-photo-page">
          {pageGroups.map((group) => (
            <div key={group.key} className="wheel-report-post-photo-block">
              <h2 className="wheel-report-photo-page-title">{group.title}</h2>
              <WheelReportPhotoPositionGroup
                slots={group.slots}
                columns={2}
                gridLayout="2x2"
                gridRows={2}
                showHeader={false}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  ));
};

export default WheelRestorationPhotoPages;
